import React from 'react';

interface VocabularyFiltersProps {
  industries: string[];
  difficultyLevels: string[];
  selectedIndustry: string;
  selectedDifficulty: string;
  onIndustryChange: (industry: string) => void;
  onDifficultyChange: (difficulty: string) => void;
  onClearFilters: () => void;
}

const VocabularyFilters: React.FC<VocabularyFiltersProps> = ({
  industries,
  difficultyLevels,
  selectedIndustry,
  selectedDifficulty,
  onIndustryChange,
  onDifficultyChange,
  onClearFilters
}) => {
  const hasActiveFilters = selectedIndustry || selectedDifficulty;

  return (
    <div className="flex flex-wrap items-center gap-4 p-4">
      {/* Industry Filter */}
      <div className="flex items-center gap-2">
        <label htmlFor="industry-filter" className="text-sm font-medium text-gray-700 dark:text-gray-300">
          Industry:
        </label>
        <select
          id="industry-filter"
          value={selectedIndustry}
          onChange={(e) => onIndustryChange(e.target.value)}
          className="px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 dark:focus:ring-indigo-400 dark:focus:border-indigo-400 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
        >
          <option value="">All Industries</option>
          {industries.map((industry) => (
            <option key={industry} value={industry}>
              {industry}
            </option>
          ))}
        </select>
      </div>

      {/* Difficulty Filter */}
      <div className="flex items-center gap-2">
        <label htmlFor="difficulty-filter" className="text-sm font-medium text-gray-700 dark:text-gray-300">
          Difficulty:
        </label>
        <select
          id="difficulty-filter"
          value={selectedDifficulty}
          onChange={(e) => onDifficultyChange(e.target.value)}
          className="px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 dark:focus:ring-indigo-400 dark:focus:border-indigo-400 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
        >
          <option value="">All Levels</option>
          {difficultyLevels.map((level) => (
            <option key={level} value={level}>
              {level.charAt(0).toUpperCase() + level.slice(1)}
            </option>
          ))}
        </select>
      </div>

      {/* Clear Filters Button */}
      {hasActiveFilters && (
        <button
          onClick={onClearFilters}
          className="px-4 py-2 text-sm text-indigo-600 hover:text-indigo-700 dark:text-indigo-400 dark:hover:text-indigo-300 font-medium transition-colors"
        >
          Clear Filters
        </button>
      )}
    </div>
  );
};

export default VocabularyFilters;
